import { useState } from 'react';
export function useCounter(initialValue) {
    const [count, setCount] = useState(initialValue !== null && initialValue !== void 0 ? initialValue : 0);
    const increment = () => {
        setCount(x => x + 1);
    };
    const decrement = () => {
        setCount(x => x - 1);
    };
    const reset = () => {
        setCount(initialValue !== null && initialValue !== void 0 ? initialValue : 0);
    };
    return {
        count,
        increment,
        decrement,
        reset,
        setCount,
    };
}
